// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const RoleAdminIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path d="M21.07 15.26c-.36-.36-2.77-1.09-3.38-1.09-.48 0-2.9.73-3.38 1.09-.36.36-.36.72-.36 1.57v1.69c0 3.01 3.26 3.86 3.5 3.98h.24c.12 0 3.5-.97 3.5-3.98V16.7c.12-.73.12-1.09-.12-1.45m-4.34-8.2c.12-3.02-2.42-5.55-5.55-5.55-3.14 0-5.56 2.53-5.56 5.55 0 3.14 2.54 5.55 5.56 5.55 3.13 0 5.55-2.53 5.55-5.55" />
      <path
        d="M9.97 15.02c-1.7 0-3.26.24-4.47.6-.72.24-1.44.6-1.93 1.09-.48.48-.84 1.2-.84 2.05s.24 1.45.84 2.05c.49.48 1.2.85 1.93 1.09 1.21.36 2.78.6 4.47.6.72 0 1.2-.48 1.2-1.2v-5.08c0-.72-.48-1.2-1.2-1.2"
        opacity=".5"
      />
    </g>
  </SvgIcon>
);

export default RoleAdminIcon;
